import { render } from "./UnitInfo.vue?vue&type=template&id=505e9a4c&scoped=true"
import script from "./UnitInfo.vue?vue&type=script&lang=js"
export * from "./UnitInfo.vue?vue&type=script&lang=js"

import "./UnitInfo.vue?vue&type=style&index=0&id=505e9a4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505e9a4c"]])

export default __exports__